import {GATEWAY_TYPE} from '@constants/gateway/gateway-type';
import {UpdateStatus} from '@models/gateway/update/update-status';
import {ConnectionStatus} from '@models/gateway/connection/connection-status';
import {StreamingDetails} from '@models/gateway/streaming-details';
import {GATEWAY_STATUS} from '@constants/gateway/gateway-status';
import {Machine} from '@models/machine/machine';
import {RebootStatus} from '@models/adminstration/gateway/gateway-reboot-status';
import {GatewayConfiguration} from '@models/adminstration/gateway/gateway-configuration';
import {GatewayIot} from '@models/adminstration/gateway/gateway-configuration/gateway-iot';
import {LogUploadStatus} from '@models/adminstration/gateway/gateway-configuration/log-upload-status';

export class Gateway {
  bqDataset: string = '';
  cloudplugType!: GATEWAY_TYPE;
  configDownloadRequested: boolean = false;
  configLastUploadTimestamp: number = -1;
  configPath: string = '';
  configUploadRequested: boolean = false;
  configViaIotBridge: boolean = false;
  connectionStatus!: ConnectionStatus;
  connectors: any;
  id: string = '';
  ibaConfig: any;
  iotCore!: GatewayIot;
  logUploadRequested: boolean = false;
  logUploadStatus?: LogUploadStatus;
  machineId: any;
  machineName: string = '';
  mysqlUnifiedTable: string = '';
  name: string = '';
  packages: any;
  parentId: number = -1;
  parentMachine: Machine | undefined;
  rebootRequest: boolean = false;
  rebootStatus?: RebootStatus;
  sampleTime: number = -1;
  sendInterval: number = -1;
  sharedSecretKey: string = '';
  sqlLengthTable: string = '';
  sqlTable: string = '';
  sqlTimeTable: string = '';
  sendingData: boolean = false;
  status!: GATEWAY_STATUS;
  streamingDetails!: StreamingDetails;
  streamingRowSizes: Map<string, number> = new Map<string, number>();
  streamingTables: string[] = [];
  tenantId: any;
  tenantName: string = '';
  updateStatus?: UpdateStatus;
  usingSharedSecretKey: boolean = false;
  configuration: GatewayConfiguration = new GatewayConfiguration();
  createdBy: string = '';
  creationTime: Date | undefined = undefined;
  externalId: string = '';
}
